var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"data-part":"wallBody","data-area":"object","data-id":_vm.obj.id,"d":_vm.d,"stroke":_vm.obj.style.stroke,"stroke-width":_vm.obj.style.strokeWidth,"stroke-dasharray":_vm.obj.style.strokeDasharray,"fill":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }